module.exports = __webpack_public_path__ + "static/media/chairman.ec86ba5f.jpg";